import { Accordion, Anchor, Box, Text, Title } from '@mantine/core';
import { EMAIL_SUPORT, SPECIALIZARE_ID, SPECIALIZARE_SPE, dataLimita } from '../constante';
import { usePlatforma, ultimaZiDeschisa } from '../platforma';

const intrebariStudenti = (ultimaZi) => [
  {
    categorie: 'Cont și profil',
    intrebari: [
      {
        q: 'Cum mă autentific în platformă?',
        a: 'Folosește contul tău instituțional Google (@stud.ase.ro). Conturile personale nu sunt acceptate.',
      },
      {
        q: 'Ce date trebuie să completez în profil?',
        a: 'Grupa, telefonul, anul de înmatriculare, forma de învățământ, anul de studiu și specializarea. Fără un profil complet nu poți vedea profesorii disponibili.',
      },
      {
        q: 'Sunt la forma de învățământ ID. Ce specializare aleg?',
        a: `La forma de învățământ ID singura specializare disponibilă este ${SPECIALIZARE_ID}, care se selectează automat. Pentru orice altă specializare trebuie să fii înscris la IF.`,
      },
      {
        q: `Sunt la specializarea ${SPECIALIZARE_SPE}. Folosesc platforma?`,
        a: `Nu. Specializarea ${SPECIALIZARE_SPE} are o altă metodă de înscriere la licență.`,
      },
    ],
  },
  {
    categorie: 'Solicitări',
    intrebari: [
      {
        q: 'Până când este disponibilă platforma?',
        a: `Platforma este disponibilă până la ${ultimaZi ? `${ultimaZi} inclusiv` : dataLimita()}. Studenții care nu au un profesor coordonator până atunci vor avea alocat unul, manual, de către directorul de departament.`,
      },
      {
        q: 'Ce se întâmplă după închiderea platformei?',
        a: 'Nu mai poți trimite solicitări, încărca cereri (nici corectate) sau modifica profilul. Poți doar să descarci cererea pe care o ai și să consulți paginile de ajutor și întrebările frecvente. Dacă nu ai un profesor coordonator, directorul de departament te va repartiza manual.',
      },
      {
        q: 'Ce este o solicitare?',
        a: 'Solicitarea este doar confirmarea unei colaborări între tine și profesor. Prin acceptarea ei, profesorul devine coordonatorul tău. Cererea oficială pentru licență (documentul PDF) se face abia după aceea.',
      },
      {
        q: 'Titlul din solicitare este cel final?',
        a: 'Nu. Titlul din solicitare este doar ORIENTATIV. După acceptare, îl stabilești împreună cu profesorul, iar titlul final este cel pe care îl treci în cererea oficială (documentul PDF).',
      },
      {
        q: 'Câte solicitări pot trimite?',
        a: 'Poți avea o singură solicitare activă (în așteptare sau acceptată) la un moment dat. Dacă este refuzată, poți trimite o nouă solicitare altui profesor.',
      },
      {
        q: 'De ce nu văd niciun profesor în listă?',
        a: 'Lista conține doar profesorii din specializarea ta care mai au locuri libere și cărora nu le-ai trimis deja o solicitare refuzată. Verifică întâi dacă profilul este complet și specializarea este corectă. Dacă nu mai sunt profesori disponibili, directorul de departament te va repartiza manual.',
      },
      {
        q: 'Pot retrage o solicitare?',
        a: 'Da, dacă nu a primit răspuns, dar doar după cel puțin 2 zile de la trimitere. După retragere poți solicita alt profesor.',
      },
      {
        q: 'Ce înseamnă „refuzată automat”?',
        a: 'Profesorul și-a ocupat toate locurile înainte să îți răspundă, așa că solicitarea ta a fost refuzată automat de platformă. Nu este un refuz din partea profesorului. Poți trimite o solicitare altui profesor, iar dacă profesorul primește locuri suplimentare, vei putea retrimite solicitarea din pagina de solicitare.',
      },
      {
        q: 'Profesorul mi-a refuzat solicitarea. Îi pot trimite alta?',
        a: 'Nu. Un refuz din partea profesorului este definitiv: acel profesor nu va mai apărea în lista ta. Poți solicita colaborarea unui alt profesor disponibil.',
      },
    ],
  },
  {
    categorie: 'Cererea de licență',
    intrebari: [
      {
        q: 'Cum generez cererea?',
        a: 'După ce solicitarea a fost acceptată, introdu titlul final, apasă „Salvează titlul”, apoi „Descarcă cererea”. Documentul este precompletat cu datele din profil și cu numele profesorului.',
      },
      {
        q: 'Cum semnez și încarc cererea?',
        a: 'Semnează documentul doar în spațiul „Semnătura student”, apoi încarcă fișierul PDF. Înainte de trimitere vei vedea o previzualizare și o verificare automată a numelor, a titlului și a semnăturii. Confirmă doar dacă toate datele sunt corecte, titlul este cel FINAL și documentul este semnat DOAR de tine.',
      },
      {
        q: 'Verificarea automată spune că ceva lipsește, dar documentul e corect. Ce fac?',
        a: 'Verificarea automată citește documentul ca pe o imagine și poate greși la scanările de calitate slabă. Ea doar avertizează. Dacă ai verificat în previzualizare că totul este corect, poți confirma și trimite cererea.',
      },
      {
        q: 'De ce apare cererea ca fiind nesemnată în ultimul tab?',
        a: 'Pentru că profesorul coordonator nu a semnat-o încă. După ce profesorul o semnează și o încarcă în platformă, vei primi un mail și vei putea descărca cererea semnată din ultimul tab.',
      },
      {
        q: 'Pot descărca cererea înainte să fie semnată de profesor?',
        a: 'Da. În ultimul tab, butonul „Descarcă cererea trimisă” descarcă exact fișierul pe care l-ai încărcat. Acesta nu este încă semnat de profesor, așa că nu îl folosi ca cerere finală.',
      },
      {
        q: 'Profesorul a solicitat modificări. Ce fac?',
        a: 'Vei primi un mail cu modificările cerute, iar mesajul apare și în pagina ta. Corectează cererea, semneaz-o din nou și încarc-o. Dacă aveai deja o cerere semnată, aceasta rămâne valabilă până când profesorul o semnează pe cea nouă.',
      },
      {
        q: 'Pot schimba titlul după ce cererea a fost semnată?',
        a: 'Doar dacă profesorul coordonator solicită modificări pentru cerere. Discută cu profesorul, iar acesta îți va deschide posibilitatea de a încărca o cerere nouă. Cererea valabilă este întotdeauna cea mai recentă cerere semnată.',
      },
      {
        q: 'Nu primesc mail-uri de la platformă.',
        a: 'Verifică folderul Spam al contului instituțional. Starea solicitării și a cererii o vezi oricând și în platformă.',
      },
    ],
  },
];

const intrebariProfesori = (ultimaZi) => [
  {
    categorie: 'Solicitări',
    intrebari: [
      {
        q: 'Până când este disponibilă platforma?',
        a: `Platforma este disponibilă până la ${ultimaZi ? `${ultimaZi} inclusiv` : dataLimita()}. După închidere nu mai puteți răspunde la solicitări, semna cereri, solicita modificări sau modifica profilul; puteți doar vizualiza și descărca cererile.`,
      },
      {
        q: 'Ce înseamnă acceptarea unei solicitări?',
        a: 'O solicitare este doar confirmarea colaborării dintre dumneavoastră și student. Titlul din solicitare este ORIENTATIV. Titlul final se stabilește împreună cu studentul și va fi cel din cererea oficială (documentul PDF).',
      },
      {
        q: 'Ce se întâmplă dacă refuz o solicitare?',
        a: 'Refuzul este definitiv: studentul nu vă va mai putea trimite o altă solicitare și nu veți mai putea colabora cu acesta prin intermediul platformei. Studentul va putea solicita un alt profesor.',
      },
      {
        q: 'Ce se întâmplă când îmi ocup toate locurile?',
        a: 'Solicitările rămase în așteptare sunt refuzate automat, iar studenții sunt anunțați pe mail că nu este un refuz din partea dumneavoastră. Dacă directorul de departament vă alocă locuri suplimentare, acești studenți vă pot retrimite solicitarea.',
      },
      {
        q: 'Cine stabilește numărul maxim de studenți?',
        a: 'Directorul de departament. Până când acesta setează limita, nu puteți primi solicitări.',
      },
      {
        q: 'De ce nu apar în lista studenților?',
        a: 'Completați gradul didactic și specializările în pagina de profil. Studenții văd doar profesorii din specializarea lor care mai au locuri libere.',
      },
    ],
  },
  {
    categorie: 'Cereri',
    intrebari: [
      {
        q: 'Cum semnez o cerere?',
        a: 'În tab-ul „De semnat”, descărcați cererea, semnați-o în spațiul coordonatorului și încărcați fișierul semnat. Înainte de trimitere veți vedea o previzualizare și o verificare automată a datelor și a semnăturilor.',
      },
      {
        q: 'Cererea are greșeli (nume, titlu, semnătură). Ce fac?',
        a: 'Folosiți „Solicită modificări” și descrieți ce trebuie corectat. Studentul primește mesajul pe mail și poate încărca o cerere corectată, care va apărea din nou la „De semnat”.',
      },
      {
        q: 'Am semnat deja o cerere, dar am observat o greșeală.',
        a: 'Puteți solicita modificări și pentru o cerere semnată, din tab-ul „Acceptate”. Cererea semnată rămâne valabilă până când o semnați pe cea nouă; cererea valabilă este întotdeauna cea mai recentă cerere semnată.',
      },
    ],
  },
];

// fiecare utilizator vede doar intrebarile pentru rolul sau
function IntrebariFrecvente({ isProfessor }) {
  const { dataInchidere } = usePlatforma();
  const ultimaZi = ultimaZiDeschisa(dataInchidere);
  const sectiuni = isProfessor ? intrebariProfesori(ultimaZi) : intrebariStudenti(ultimaZi);

  return (
    <Box bg="white" p={{ base: 'md', sm: 50 }} m={{ base: '80px 8px', sm: '100px 20px' }}>
      <Title order={2} style={{color: 'darkblue'}}  mb="md">Întrebări frecvente</Title>
      {sectiuni.map((sectiune) => (
        <Box key={sectiune.categorie} mb="lg">
          <Title order={4} mb="xs">{sectiune.categorie}</Title>
          <Accordion variant="separated">
            {sectiune.intrebari.map((item) => (
              <Accordion.Item key={item.q} value={item.q}>
                <Accordion.Control>{item.q}</Accordion.Control>
                <Accordion.Panel>{item.a}</Accordion.Panel>
              </Accordion.Item>
            ))}
          </Accordion>
        </Box>
      ))}
      <Text size="sm" mt="xl">
        {isProfessor ? 'Nu ați găsit răspunsul? Scrieți-ne la' : 'Nu ai găsit răspunsul? Scrie-ne la'}{' '}
        <Anchor href={`mailto:${EMAIL_SUPORT}`}>{EMAIL_SUPORT}</Anchor>.
      </Text>
    </Box>
  );
}

export default IntrebariFrecvente;
